var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckGreen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2429_6180)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.7582 7.47091L9.72696 17.5022C9.49256 17.7364 9.17475 17.868 8.84337 17.868C8.51199 17.868 8.19417 17.7364 7.95977 17.5022L2.36446 11.8772C2.13046 11.6428 1.99902 11.3251 1.99902 10.994C1.99902 10.6628 2.13046 10.3451 2.36446 10.1108L3.92696 8.54825C4.16123 8.31496 4.47838 8.18398 4.80899 8.18398C5.13961 8.18398 5.45675 8.31496 5.69102 8.54825L8.87462 11.6358L16.434 4.16934C16.6683 3.93582 16.9856 3.80469 17.3164 3.80469C17.6472 3.80469 17.9645 3.93582 18.1988 4.16934L19.7574 5.69591C19.8746 5.81206 19.9677 5.95027 20.0312 6.10257C20.0948 6.25486 20.1275 6.41823 20.1276 6.58324C20.1276 6.74826 20.095 6.91166 20.0316 7.06401C19.9683 7.21636 19.8753 7.35465 19.7582 7.47091Z",
    fill: "#04D9B5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2429_6180"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.75 0.369141)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckGreen);
export default __webpack_public_path__ + "static/media/check-green.614be847adf0df9c0320de174fab8f8d.svg";
export { ForwardRef as ReactComponent };